//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { BooleanResultDTO } from 'src/app/core/interfaces/general/boolean-result';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { SystemLockDTO } from 'src/app/core/models/system/system-lock/system-lock.dto';

@Injectable({ providedIn: 'root' })

export class SystemLockService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
  
  public entityIsLocked(systemLock: SystemLockDTO): Observable<SystemLockDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(systemLock))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.SystemLocks + "/" +
                                                               eSimApiPaths.SystemLocksEntityIsLocked +
                                                               "?objectEnc=" + objectEnc,
                                                               {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public lockEntity(systemLock: SystemLockDTO): Observable<SystemLockDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(systemLock))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.SystemLocks +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public removeAllUserSystemLocks(userID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.SystemLocks + "/" +
                                                               eSimApiPaths.SystemLocksRemoveAllUserSystemLocks +
                                                               "?userIdEncSS=" + userIdEncSS, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public unlockEntity(id: number): Observable<SystemLockDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.delete(environment.eSimApi +
                                                                 eSimApiPaths.SystemLocks +
                                                                 "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
